import React, {Component} from 'react'
import ReactDOM from 'react-dom'
import ReactGA from 'react-ga'
import * as Sentry from '@sentry/browser'
import {observer} from 'mobx-react'

import {AppContainer} from 'react-hot-loader'
import {StripeProvider} from 'react-stripe-elements'
import {Provider} from 'mobx-react'
import {BrowserRouter} from 'react-router-dom'

import library from './icons' //eslint-disable-line no-unused-vars

import AppWrapper from './components/AppWrapper'
import {Store} from './store'
import './antd.config.js'

import './css/core.css'

const store = new Store()
if (process.env.SENTRY) {
  Sentry.init({
    dsn: 'https://e3145e5ac962450ebc5344429a96cdab@sentry.io/1277024',
    release: `ui-${process.env.SENTRY}@${process.env.COMMITHASH}`,
    integrations: [new Sentry.Integrations.RewriteFrames()]
  })
}

ReactGA.initialize('UA-91240144-1')
ReactGA.pageview(window.location.pathname + window.location.search)

@observer
class Root extends Component {
  constructor(props) {
    super(props)
    this.store = store
  }
  render() {
    return(
      <AppContainer>
        <BrowserRouter basename='/'>
          <StripeProvider apiKey={process.env.STRIPE_KEY}>
            <Provider store={this.store}>
              <AppWrapper/>
            </Provider>
          </StripeProvider>
        </BrowserRouter>
      </AppContainer>
    )
  }
}

const render = Component => {
  ReactDOM.render(
    <Component/>,
    document.getElementById('root')
  )
}

render(Root)

if (module.hot) {
  module.hot.accept()
}
